export default "__VITE_ASSET__7b0458ef__"